import React, { useState } from 'react';
import SEO from '../components/SEO';
import axios from 'axios';
import { toast } from 'sonner';

const ContactPage = () => {

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;
    setIsSubmitting(true);
    
    /*const payload = {
      to: "hr@abacies.com",
      content: {
        name: formData.name,
        email: formData.email,
        message: formData.message
      }
    };*/

    const payload = {
      full_name: formData.name,
      email: formData.email,
      message: formData.message
    };

    try {
      await axios.post(
        `https://platinumlist-backend-staging.abacies.com/api/v1/test_endpoint/abacies_contact_form`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
            "X-API-Key": "wFn6McdbHTJqH6nEIHBfjhLQMYxJuhsHg0HM7hu6Oqk"
          }
        }
      );

      toast.success("Message sent successfully!");

      setFormData({
        name: "",
        email: "",
        company: "",
        phone: "",
        subject: "",
        message: ""
      });

    } catch (error) {
      console.error("Send message error:", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <>
      <SEO 
        title="Contact Us - Get in Touch with Our Expert Team"
        description="Contact Abacies Logiciels for AI solutions, custom software development, and digital transformation services. Get a free consultation with our experts."
        keywords="contact Abacies, get quote, consultation, AI solutions contact, software development inquiry"
      />

      {/* Hero Section */}
      <section className="hero-section py-10">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Get in <span className="text-gradient">Touch</span>
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              Ready to transform your business with AI and custom software solutions? Let's discuss how we can help you achieve your goals.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Form & Info */}
      <section className="py-6 md:py-6 bg-white">
        <div className="page-container pb-8">
          <div className="grid lg:grid-cols-3 gap-12">
            {/* Contact Information */}
            <div className="lg:col-span-1">
              <div className="card mb-10">
                <h3 className="text-xl font-semibold mb-4 text-charcoal">Our Address</h3>
                <div className="space-y-3 text-titanium">
                  <p className="flex items-start">
                    <svg
                      className="w-5 h-5 text-primary-red mr-3 mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span>Abacies Logiciels Private Limited<br/>1st Floor, Greentouch, Carnival Building, Infopark Phase 1,<br/>Kakkanad Ernakulam, Kerala - 682042</span>
                  </p>

                  {/* <p className="flex items-center">
                    <svg className="w-5 h-5 text-primary-red mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                    </svg>
                    <span>+91 9035582577</span>
                  </p>

                  <p className="flex items-center">
                    <svg
                      className="w-5 h-5 text-primary-red mr-3 flex-shrink-0"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                    </svg>
                    <span>contact@abacies.com</span>
                  </p> */}
                </div>
              </div>

              <div className="card mb-10">
                <h3 className="text-xl font-semibold mb-4 text-charcoal">Office Hours</h3>
                <div className="space-y-2 text-titanium">
                  <p>Monday - Friday: 9:00 AM - 6:00 PM IST</p>
                  <p>Saturday: Closed</p>
                  <p>Sunday: Closed</p>
                  <p className="text-primary-red font-semibold mt-3">24/7 Enterprise Support Available</p>
                </div>
              </div>

              <div className="card">
                <h3 className="text-xl font-semibold mb-4 text-charcoal">Follow Us</h3>
                <div className="flex space-x-4">
                  <a href="#" className="w-10 h-10 bg-blush-light/40 rounded-lg flex items-center justify-center hover:bg-primary-red hover:text-white transition-all duration-300">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-10 h-10 bg-blush-light/40 rounded-lg flex items-center justify-center hover:bg-primary-red hover:text-white transition-all duration-300">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
                    </svg>
                  </a>
                  <a href="#" className="w-10 h-10 bg-blush-light/40 rounded-lg flex items-center justify-center hover:bg-primary-red hover:text-white transition-all duration-300">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2 h-full">
              <div className="card h-full flex flex-col">
                <h2 className="text-2xl font-bold mb-6 text-charcoal">Send Us a Message</h2>
                <form onSubmit={handleSubmit} className="flex flex-col flex-1">
                  <div className="grid md:grid-cols-2 gap-6 mb-8">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-charcoal mb-2">
                        Full Name *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-platinum rounded-lg focus:outline-none focus:border-primary-red transition-colors"
                        placeholder="John Doe"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-charcoal mb-2">
                        Email Address *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-platinum rounded-lg focus:outline-none focus:border-primary-red transition-colors"
                        placeholder="john@company.com"
                      />
                    </div>
                  </div>

                  {/* <div className="grid md:grid-cols-2 gap-6 mb-6">
                    <div>
                      <label htmlFor="company" className="block text-sm font-medium text-charcoal mb-2">
                        Company Name
                      </label>
                      <input
                        type="text"
                        id="company"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-platinum rounded-lg focus:outline-none focus:border-primary-red transition-colors"
                        placeholder="Acme Corporation"
                      />
                    </div>
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-charcoal mb-2">
                        Phone Number
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        className="w-full px-4 py-3 border border-platinum rounded-lg focus:outline-none focus:border-primary-red transition-colors"
                        placeholder="+1 (555) 123-4567"
                      />
                    </div>
                  </div> */}

                  {/* <div className="mb-6">
                    <label htmlFor="subject" className="block text-sm font-medium text-charcoal mb-2">
                      Subject *
                    </label>
                    <select
                      id="subject"
                      name="subject"
                      required
                      value={formData.subject}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-platinum rounded-lg focus:outline-none focus:border-primary-red transition-colors"
                    >
                      <option value="">Select a subject</option>
                      <option value="project">New Project Inquiry</option>
                      <option value="consultation">Request Consultation</option>
                      <option value="support">Technical Support</option>
                      <option value="partnership">Partnership Opportunity</option>
                      <option value="career">Career Inquiry</option>
                      <option value="other">Other</option>
                    </select>
                  </div> */}

                  <div className="mb-8 flex flex-col flex-1">
                    <label htmlFor="message" className="block text-sm font-medium text-charcoal mb-2">
                      Message *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      rows="6"
                      value={formData.message}
                      onChange={handleChange}
                      className="w-full px-4 py-3 flex-1 border border-platinum rounded-lg focus:outline-none focus:border-primary-red transition-colors resize-none"
                      placeholder="Tell us about your project or inquiry..."
                    />
                  </div>

                  <div className="mt-auto flex flex-col sm:flex-row gap-4">
                    <button type="submit" disabled={isSubmitting} className={`btn-primary flex items-center justify-center gap-2 ${
                      isSubmitting ? "opacity-70 cursor-not-allowed" : ""
                    }`}>
                      {isSubmitting && (
                        <svg
                          className="w-4 h-4 animate-spin"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                          />
                        </svg>
                      )}
                      {isSubmitting ? "Sending..." : "Send Message"}
                    </button>
                    {/* <button type="button" className="btn-secondary">
                      Schedule a Call
                    </button> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Office Locations */}
      <section className="py-3 md:py-3 bg-alabaster">
        <div className="page-container">
          <h2 className="section-title text-center">Our Offices</h2>
          <p className="section-subtitle text-center max-w-2xl mx-auto mb-12">
            Visit us at any of our office locations
          </p>

          {/* GRID */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
            
            {/* LEFT COLUMN: ADDRESSES */}
            <div className="flex flex-col gap-6">
              
                <div className="card">
                <span className="inline-block mb-3 px-3 py-1 text-xs font-semibold text-primary-red bg-red-50 rounded-full">
                  Registered Office
                </span>
                <p className="text-titanium leading-relaxed">
                  Abacies Logiciels Private Limited<br />
                  1st Floor, Greentouch, Carnival Building<br />
                  Infopark Phase 1, Kakkanad<br />
                  Ernakulam, Kerala – 682042
                </p>
              </div>

              <div className="card">
                <span className="inline-block mb-3 px-3 py-1 text-xs font-semibold text-primary-red bg-red-50 rounded-full">
                  Head Office
                </span>
                <p className="text-titanium leading-relaxed">
                  #235, 2nd &amp; 3rd Floor, 13th Cross Rd<br />
                  Indira Nagar II Stage, Hoysala Nagar<br />
                  Indiranagar, Bengaluru, Karnataka – 560038
                </p>
              </div>

            </div>

            {/* RIGHT: MAP */}
            <div className="card p-0 overflow-hidden flex">
              <iframe
                title="Abacies Office Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.032552707478!2d76.36095997457252!3d10.014169790091929!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b080de74cd7e8fb%3A0x86fa4af1ed3afc08!2sAbacies%20Logiciels%20Private%20Limited!5e0!3m2!1sen!2sin!4v1769762699487!5m2!1sen!2sin"
                className="w-full h-full border-0"
                allowfullscreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
